import cn from 'classnames';
import { format } from 'date-fns';
import { isEmpty } from 'lodash';
import T from 'prop-types';
import React from 'react';
import './metromapLogo.scss';
export var METROMAP_LOGO_ID = 'metromap-logo-wrapper';
var MetromapLogo = function(props) {
    var isVisible = props.isVisible, mapTypeId = props.mapTypeId, tileDate = props.tileDate;
    return /*#__PURE__*/ React.createElement("div", {
        id: METROMAP_LOGO_ID,
        className: cn({
            is_visible: isVisible
        })
    }, mapTypeId === 'highres' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("img", {
        className: "metromap-logo",
        src: "/public/img/metromap_logo.png",
        alt: "metromap_logo_red"
    }), !isEmpty(tileDate) && /*#__PURE__*/ React.createElement("div", {
        className: "metromap-logo-datetime-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "metromap-logo-datetime"
    }, format(new Date(tileDate), 'dd/MM/yyyy')))) : /*#__PURE__*/ React.createElement("div", {
        className: "metromap-logo-datetime-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "metromap-logo-datetime"
    }, "\xa9 ", /*#__PURE__*/ React.createElement("a", {
        href: "//www.linz.govt.nz/linz-copyright"
    }, "LINZ CC BY 4.0"), " | \xa9", ' ', /*#__PURE__*/ React.createElement("a", {
        href: "//www.linz.govt.nz/data/linz-data/linz-basemaps/data-attribution"
    }, "Imagery Basemap contributors"))));
};
MetromapLogo.propTypes = {
    isVisible: T.bool.isRequired
};
export default MetromapLogo;
